import { fork } from 'redux-saga/effects';
import { watchLinkAccountSagas } from './sagas/link-account-sagas';
import { watchSwitchAccountSagas } from './sagas/switch-account-sagas';

export const accountSettingsSagas = [fork(watchLinkAccountSagas), fork(watchSwitchAccountSagas)];
